import { Component, Vue, Prop } from 'vue-property-decorator';

import { TwoColumnTextBlockViewModel } from './TwoColumnTextModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import Tick from '@/assets/icons/tick.svg?inline';
import Plus from '@/assets/icons/plus.svg?inline';
import Minus from '@/assets/icons/minus.svg?inline';

const TwoColumnTextModuleProps = Vue.extend({
  props: getComponentProps<TwoColumnTextBlockViewModel>({
    Title: 'Expedition Highlights',
    Text:
      'Choose from seven Alaska adventure tours that sail among the wildlife-rich islands and channels of Alaska aboard five ships: and select photo expeditions include National Geographic photographers.',
    Items: [
      'Semper feugiat nibh sed pulvinar proin gravida hendrerit lectus.',
      'Semper feugiat nibh sed pulvinar proin gravida hendrerit lectus.',
      'Semper feugiat nibh sed pulvinar proin gravida hendrerit lectus.',
    ],
    ListTitle: 'HIGHLIGHTS',
  }),
});

@Component({
  components: {
    Tick,
    Plus,
    Minus,
  },
})
export default class TwoColumnTextModule extends TwoColumnTextModuleProps {
  isHidden = true;
  ariaPressed = false;

  openMenu() {
    this.isHidden = !this.isHidden;
    this.ariaPressed = !this.ariaPressed;
  }

  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.changeList);
      this.changeList();
    });
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.changeList);
  }

  windowWidth!: number;
  changeList() {
    //Mobile width
    if (this.windowWidth < 425) return;

    const newWidth = document.documentElement.clientWidth;
    const widthHasChanged = newWidth !== this.windowWidth;

    this.windowWidth = newWidth;

    this.isHidden = widthHasChanged ? this.windowWidth < 1200 : this.windowWidth >= 1200;
  }
}
